"use client";
import { cn } from "@/lib/utils";
import React from "react";

interface ButtonAssessmentProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  type: "checkbox" | "radio";
  name: string;
  value: string;
  label: string;
  description?: string;
  className?: string;
}

const ButtonAssessment: React.FC<ButtonAssessmentProps> = ({
  type,
  name,
  value,
  label,
  description = "",
  className,
  ...props
}) => {
  return (
    <label
      htmlFor={type + "-" + name + "-" + value}
      className={cn(
        "group block cursor-pointer select-none rounded-full border border-neutral-400 bg-white px-6 py-2 text-center transition-colors hover:border-neutral-200 hover:bg-secondary-100 active:border-transparent active:bg-secondary-500 has-[:checked]:bg-secondary-500",
        className
      )}
    >
      {type === "checkbox" ? (
        <input
          type="checkbox"
          id={"checkbox-" + name + "-" + value}
          name={name}
          value={value}
          className="peer hidden"
          {...props}
        />
      ) : (
        <input
          type="radio"
          id={"radio-" + name + "-" + value}
          name={name}
          value={value}
          className="peer hidden"
          {...props}
        />
      )}

      <p
        className={cn(
          "font-roboto text-body-1-400 text-neutral-600 group-active:text-white peer-checked:text-white"
        )}
      >
        {label}
      </p>
      <p className="font-roboto text-body-1-300 text-neutral-400 group-hover:text-neutral-400 group-active:text-neutral-100 peer-checked:text-neutral-100">
        {description}
      </p>
    </label>
  );
};

export default ButtonAssessment;
